import { useTranslation } from 'react-i18next';
import Faq from './Faq';
import './FaqsSubsection.scss';
import { useEffect, useState } from 'react';

const FaqsSubsection = ({ id, sectionId, title, faqs, reset, setReset }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (reset) {
      faqs.forEach((faq) => (faq.expanded = false));
      setExpanded(false);
      setReset(false);
    }
  }, [reset, setReset, faqs]);

  function onExpandAllToggle() {
    faqs.forEach((faq) => (faq.expanded = !expanded));
    setExpanded(!expanded);
  }

  return (
    <div className="faqs-subsection" id={`sec-${sectionId}-subsec-${id}`}>
      <div className="faqs-subsection-header">
        <span className="faqs-subsection-title">{title}</span>
        {faqs && faqs.length > 1 ? (
          <span className="faqs-subsection-link" onClick={onExpandAllToggle}>
            {expanded ? t('faqs.collapseAll') : t('faqs.expandAll')}
          </span>
        ) : (
          ''
        )}
      </div>
      {faqs &&
        faqs.length > 0 &&
        faqs.map((faq, faqInd) => (
          <Faq
            question={faq.question}
            answer={faq.answer}
            id={`sec-${sectionId}-subsec-${id}-faq-${faqInd}`}
            onExpandToggle={(expand) => {
              faq.expanded = expand;
              if (faqs.every((faq) => faq.expanded)) setExpanded(true);
              else if (faqs.every((faq) => !faq.expanded)) setExpanded(false);
            }}
            defaultExpanded={reset ? false : expanded}
            selected={reset ? false : faq.selected}
          />
        ))}
    </div>
  );
};

export default FaqsSubsection;
